export default {
  to: 'To',
  enterNameOrNumber: 'Enter name or number',
} as const;
